import gql from 'graphql-tag';
const ASSET_FRAGMENT = gql `
  fragment AssetFragment on Asset {
    id
    captions
    description
    filename
    src
    title
    vtt
    vttFilename
    narrationSrc
    narrationVtt
  }
`;
export default ASSET_FRAGMENT;
